var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","ripple":false},on:{"click":function($event){return _vm.$function.movePage(_vm.$pages.CASH.name)}}},[_c('v-icon',{attrs:{"color":_vm.additionalBtnColor}},[_vm._v(" mdi-alpha-c-circle-outline ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }